import KanbanStagesAPI from '../../api/kanbanStages';

const SET_KANBAN_STAGES_UI_FLAG = 'SET_KANBAN_STAGES_UI_FLAG';
const SET_KANBAN_STAGES = 'SET_KANBAN_STAGES';
const ADD_KANBAN_STAGE = 'ADD_KANBAN_STAGE';
const EDIT_KANBAN_STAGE = 'EDIT_KANBAN_STAGE';
const DELETE_KANBAN_STAGE = 'DELETE_KANBAN_STAGE';

export const state = {
  records: [],
  uiFlags: {
    isFetching: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
  },
};

export const getters = {
  getStages(_state) {
    return _state.records.sort((a, b) => a.position - b.position);
  },
  getUIFlags(_state) {
    return _state.uiFlags;
  },
  getStageById: _state => id => {
    return _state.records.find(record => record.id === Number(id));
  },
};

export const actions = {
  async get({ commit }) {
    commit(SET_KANBAN_STAGES_UI_FLAG, { isFetching: true });
    try {
      const response = await KanbanStagesAPI.get();
      commit(SET_KANBAN_STAGES, response.data.payload);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_STAGES_UI_FLAG, { isFetching: false });
    }
  },
  async create({ commit }, stageData) {
    commit(SET_KANBAN_STAGES_UI_FLAG, { isCreating: true });
    try {
      const response = await KanbanStagesAPI.create(stageData);
      commit(ADD_KANBAN_STAGE, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_STAGES_UI_FLAG, { isCreating: false });
    }
  },
  async update({ commit }, { id, ...updateObj }) {
    commit(SET_KANBAN_STAGES_UI_FLAG, { isUpdating: true });
    try {
      const response = await KanbanStagesAPI.update(id, updateObj);
      commit(EDIT_KANBAN_STAGE, response.data);
      return response.data;
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_STAGES_UI_FLAG, { isUpdating: false });
    }
  },
  async delete({ commit }, id) {
    commit(SET_KANBAN_STAGES_UI_FLAG, { isDeleting: true });
    try {
      await KanbanStagesAPI.delete(id);
      commit(DELETE_KANBAN_STAGE, id);
    } catch (error) {
      throw new Error(error);
    } finally {
      commit(SET_KANBAN_STAGES_UI_FLAG, { isDeleting: false });
    }
  },
  async reorder({ commit }, stages) {
    try {
      const response = await KanbanStagesAPI.reorder(stages);
      commit(SET_KANBAN_STAGES, response.data.payload);
    } catch (error) {
      throw new Error(error);
    }
  },
};

export const mutations = {
  [SET_KANBAN_STAGES_UI_FLAG](_state, data) {
    _state.uiFlags = { ..._state.uiFlags, ...data };
  },
  [SET_KANBAN_STAGES](_state, data) {
    _state.records = data;
  },
  [ADD_KANBAN_STAGE](_state, data) {
    _state.records.push(data);
  },
  [EDIT_KANBAN_STAGE](_state, data) {
    const index = _state.records.findIndex(r => r.id === data.id);
    if (index !== -1) _state.records.splice(index, 1, data);
  },
  [DELETE_KANBAN_STAGE](_state, id) {
    _state.records = _state.records.filter(r => r.id !== id);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
